export default function ShippingPolicy() {
  return (
    <main className="min-h-screen bg-[#f0f4f7]">
      <section className="bg-[#2c2a4a] py-14 md:py-20">
        <div className="container-main text-center">
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">Shipping Policy</h1>
          <p className="text-white/70 text-base md:text-lg">How we get your garden art to you, fast and safe.</p>
        </div>
      </section>

      <section className="py-10 md:py-14">
        <div className="container-main max-w-3xl">
          <div className="space-y-8 text-[#4A4A4A] font-sans text-base leading-relaxed">
            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Shipping Rates</h2>
              <p className="mb-4">
                We ship every order from our warehouse in <strong className="text-[#1A1A1A]">Madison, Wisconsin</strong>. Shipping prices are based upon the most expensive item in your cart.
              </p>
              <div className="overflow-x-auto">
                <table className="w-full border border-[#D4C9B8] rounded-lg">
                  <thead className="bg-[#FAF8F4]">
                    <tr>
                      <th className="text-left px-4 py-3 text-sm font-semibold text-[#1A1A1A] border-b border-[#D4C9B8]">Item</th>
                      <th className="text-right px-4 py-3 text-sm font-semibold text-[#1A1A1A] border-b border-[#D4C9B8] w-32">Shipping</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-[#E8E0D4]">
                      <td className="px-4 py-3 text-sm">Wire Wrap Pendant</td>
                      <td className="px-4 py-3 text-sm text-right font-semibold text-[#2c2a4a]">$5.00</td>
                    </tr>
                    <tr className="border-b border-[#E8E0D4]">
                      <td className="px-4 py-3 text-sm">Soapstone Animal</td>
                      <td className="px-4 py-3 text-sm text-right font-semibold text-[#2c2a4a]">$5.00</td>
                    </tr>
                    <tr className="border-b border-[#E8E0D4]">
                      <td className="px-4 py-3 text-sm">Battery</td>
                      <td className="px-4 py-3 text-sm text-right font-semibold text-[#2c2a4a]">$10.00</td>
                    </tr>
                    <tr className="border-b border-[#E8E0D4]">
                      <td className="px-4 py-3 text-sm">Small Spinner</td>
                      <td className="px-4 py-3 text-sm text-right font-semibold text-[#2c2a4a]">$10.00</td>
                    </tr>
                    <tr className="border-b border-[#E8E0D4]">
                      <td className="px-4 py-3 text-sm">Medium Spinner</td>
                      <td className="px-4 py-3 text-sm text-right font-semibold text-[#2c2a4a]">$18.00</td>
                    </tr>
                    <tr className="border-b border-[#E8E0D4]">
                      <td className="px-4 py-3 text-sm">Giant Spinner</td>
                      <td className="px-4 py-3 text-sm text-right font-semibold text-[#2c2a4a]">$25.00</td>
                    </tr>
                    <tr className="border-b border-[#E8E0D4]">
                      <td className="px-4 py-3 text-sm">Tail</td>
                      <td className="px-4 py-3 text-sm text-right font-semibold text-[#2c2a4a]">$18.00</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-sm">Spinner + Tail</td>
                      <td className="px-4 py-3 text-sm text-right font-semibold text-[#2c2a4a]">$24.80</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-sm text-[#8B7355] mt-3 italic">
                Prices are based upon the most expensive item in your order.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Processing Time</h2>
              <p>
                Orders are typically processed and shipped within <strong className="text-[#1A1A1A]">1-2 business days</strong> of payment confirmation. During peak seasons (holidays, spring garden season), processing may take up to 3 business days. You will receive a shipping confirmation email with tracking information once your order has been dispatched.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Delivery Time</h2>
              <p>
                Standard shipping within the continental United States typically takes <strong className="text-[#1A1A1A]">3-5 business days</strong>. Alaska, Hawaii, and US territories may require 5-10 business days. We currently ship via USPS Priority Mail and UPS Ground. At checkout, you may see estimated delivery dates based on your location.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Packaging</h2>
              <p>
                Every wind spinner, soapstone animal, and wire-wrapped stone is carefully packed by hand in Madison, WI. Wind spinners are protected with bubble wrap and rigid cardboard to prevent bending during transit. Soapstone animals are wrapped in soft tissue and cushioned to prevent chips. We take pride in ensuring your art arrives in perfect condition.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">Tracking Your Order</h2>
              <p>
                Once your order ships, you will receive an email with a tracking number. You can also contact us at <a href="mailto:Spinworld@myyahoo.com" className="text-[#4f528d] hover:underline">Spinworld@myyahoo.com</a> or call <a href="tel:907-500-8881" className="text-[#4f528d] hover:underline">907-500-8881</a> for order status updates.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mb-3">International Shipping</h2>
              <p>
                At this time, we only ship within the United States and Canada. International customers outside North America may contact us for special shipping arrangements, though additional fees and longer delivery times will apply.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}